import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import willBaxter from '../images/willBaxter.jpg';
import willBaxterCrop from '../images/willBaxterCrop.jpg';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    hero: {
      display: 'inline-block',
      width: '100%',
      height: '95vh',
      position: 'relative',

    },
    diagonalHeroGg: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '95vh',
      borderBottom: '6px solid #0076bb',
      [theme.breakpoints.up('sm')]: {
        backgroundImage: `url(${willBaxter})`,
      },
      backgroundImage: `url(${willBaxterCrop})`,
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      marginTop: '-80px',
      opacity: '0.9',
    },
    text: {

      [theme.breakpoints.up('sm')]: {
        top: '30%',
      },

      position: 'absolute',

      padding: '5px',
    },
    title: {
      [theme.breakpoints.up('sm')]: {
        fontSize: '4em',
      },
      color: 'white',
      fontSize: '3em',
      fontWeight: 'bold'
    },
    adress: {
      position: 'absolute',
      bottom: '100px',
      padding: '5px',
      color: 'white',
    },
    adressTitle: {
      [theme.breakpoints.up('sm')]: {
      },
    },
    copyText: {
      [theme.breakpoints.up('sm')]: {
        bottom: '85px',
        right: '10px',
        display: 'block',
      },
      position: 'absolute',
      display: 'none',
      color: 'white',
      fontStyle: 'italic',
    },
    publicationText: {
      [theme.breakpoints.up('sm')]: {
        right: '20px',
        top: '-80px',
        display: 'block',
      },
      position: 'absolute',
      display: 'none',
      color: 'white',
      fontSize: '2em',
    },

  }),
);

const Hero = () => {
  const classes = useStyles();
  return (
    <div className={classes.hero}>
      <div className={classes.diagonalHeroGg}></div>
      <Container>
        <div className={classes.text}>
          <Typography variant="h1" className={classes.title}>
            WFP-EU 2019 Partnership Report
          </Typography>
        </div>

        <div className={classes.adress}>
          <Typography variant="h5" className={classes.adressTitle}>
            <b>World Food Programme • </b> Office to the European Union • Rue d’Arlon 80 – 1040 Brussels
          </Typography>
        </div>
        <p className={classes.copyText}> &copy; WFP/Will Baxter</p>
        <p className={classes.publicationText}>August 2020</p>
      </Container>
    </div>
  );
};

export default Hero;
